import { Component, Prop, Vue } from "vue-property-decorator";
import { Module } from "@/store/enums.ts";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import RadioTable from "@/components/RadioTable.tsx";
import { db, userDataCollection } from "@/firebase";
import { updateStudentScoring } from "@/service/DashboardBackend";

@Component
export default class BalliAttitude extends Vue {
  completed = false;
  private _questions: [{ question: string; answer: number; qid: number }];
  private introCompleted = false;

  constructor() {
    super();
    this._questions = this.$store.getters.balliQuestions.attitude;
  }

  beforeCreate() {
    this._questions = this.$store.getters.balliQuestions.attitude;
  }

  hasCompleted(completed: boolean) {
    this.completed = completed;
  }

  getData() {
    let data: any = [];
    this._questions.forEach(function(item) {
      data.push({
        question: item.question,
        answer: item.answer, // answer '1' maps to '0' (and so on...) on the responses list.
        qid: item.qid
      });
    });
    return data;
  }

  submit() {
    var thisUser = this.$store.getters.user;
    var uid = thisUser.data.uid;

    if (this.$store.getters.balliSections[2].progress != 100) {
      let timepoint = this.$store.getters.balliTimepointStr;
      updateStudentScoring();
      var data = this.getData();

      // Store the responses
      userDataCollection
        .doc(uid)
        .collection("balli")
        .doc(timepoint)
        .collection("responses")
        .doc("attitude")
        .set({ Answers: data })
        .then(function() {
          userDataCollection
            .doc(uid)
            .collection("balli")
            .doc(timepoint)
            .update({
              "completionStatus.attitude": {
                status: true,
                dateCompleted: Date.now()
              }
            });
        })
        .catch(function(error) {
          //console.error("Error writing responses for Balli Ability: ", error);
        });

      // Update progress in $store
      this.$store.commit("markBalliComplete", "Attitude");
      this.$store.commit("progressBalli", this._questions.length);
    }

    // Move to Regulation
    this.$router.push({ name: "balliRegulation" });
  }

  statedLoaded() {
    return this.$store.getters.balliQuestionsLoaded;
  }

  private introScreen() {
    return (
      <Card>
        <div slot="mainContent">
          <span class="subtitle-1">
            Now, tell us about your attitude towards reading and writing!
          </span>
        </div>
        <div slot="actions">
          <v-btn
            color="primary"
            onClick={() => {
              this.introCompleted = true;
            }}
          >
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(
              (this.$store.getters.progressBalli /
                this.$store.getters.numBalliQuestions) *
                100
            )}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }

  private mainContent() {
    return (
      <Card
        title="Think about your attitude towards reading and writing. Does this sound like you?"
        mod={Module.BALLI}
      >
        <v-form ref="form" slot="mainContent">
          <RadioTable
            questions={this._questions}
            onUpdate={this.hasCompleted}
            fixHeader={true}
            disabled={this.$store.getters.balliSections[2].progress == 100}
            labelType={this.$store.getters.balliRadioHeader}
          ></RadioTable>
        </v-form>
        <div slot="actions">
          <v-spacer></v-spacer>
          <v-btn color="primary" to="ability">
            Back
          </v-btn>
          <v-btn
            color="primary"
            disabled={!this.completed}
            onClick={this.submit}
          >
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(
              (this.$store.getters.progressBalli /
                this.$store.getters.numBalliQuestions) *
                100
            )}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }

  render(h: CreateElement) {
    return this.introCompleted
      ? this.statedLoaded()
        ? this.mainContent()
        : ""
      : this.introScreen();
  }
}

const component = BalliAttitude;
